import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import React from 'react';
import { renderRoutes } from 'react-router-config';
import { createThemeYH } from '@cp/ds';
import { TokenProvider } from 'src/shared/ui/theme';
import { DEFAULT_THEME_NAME } from 'src/app/shared/const/layout';
import { AppToastManager } from '@cp/shared/toast';
import { Global } from '@emotion/react';
import { ContainerCssTokens } from '@youhelp-ru/ui';
import { ModalLayoutTokens } from '@cp/ds/src/components/modalLayout';
import { ProcessingCountersProvider } from 'src/widgets/processingAndReviews';
import { routesConfig } from './routes';
import { ModalProvider } from './shared/components/modalProvider';
import { ResumeViewerProvider } from './providers/resumeViewer';
import { RouterProvider } from './providers/router';
import { ClientWebRouteResolver } from './providers/routeResolver';
import { ConfigContextProvider } from './config';
import { AppModalManager } from './providers/modal';

const theme = createThemeYH(DEFAULT_THEME_NAME);
export const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <Global
        styles={{
          ':root': {
            [ContainerCssTokens.offset]: theme.spacing(1.5),
            [ModalLayoutTokens.Radius]: `${theme.borderRadius.large}px`,
            [ModalLayoutTokens.PaperColor]: theme.palette.background.paper,
            [ModalLayoutTokens.PullerColor]: theme.palette['gray light'],
          },
          [theme.breakpoints.up('md')]: {
            ':root': {
              [ContainerCssTokens.offset]: theme.spacing(4),
              [ContainerCssTokens.width]: '900px',
              [ModalLayoutTokens.Radius]: `${theme.borderRadius.extraLarge}px`,
              [ModalLayoutTokens.ContainerWidth]: '415px',
            },
          },
          [theme.breakpoints.up('lg')]: {
            ':root': {
              [ContainerCssTokens.width]: '1200px',
            },
          },
        }}
      />
      {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
      <CssBaseline />
      <ConfigContextProvider>
        <RouterProvider>
          <TokenProvider>
            <ClientWebRouteResolver>
              <ResumeViewerProvider>
                <ProcessingCountersProvider>
                  {renderRoutes(routesConfig)}
                  <ModalProvider />
                  <AppModalManager />
                </ProcessingCountersProvider>
              </ResumeViewerProvider>
            </ClientWebRouteResolver>
          </TokenProvider>
        </RouterProvider>
      </ConfigContextProvider>
      <AppToastManager />
    </ThemeProvider>
  );
};
